import {
  SET_FLASH_MESSAGE,
  HIDE_FLASH_MESSAGE,
} from '../actions/notifications';

export const initialState = {
  messages: [],
};

export default function notifications(state = initialState, action) {
  switch (action.type) {
    case SET_FLASH_MESSAGE:
      return {
        ...state,
        messages: [...state.messages, {
          id: action.id,
          text: action.text,
          level: action.level,
          sticky: action.sticky,
        }],
      };
    case HIDE_FLASH_MESSAGE: {
      const messages = state.messages.filter(message => message.id !== action.id);
      return { ...state, messages };
    }
    default:
      return state;
  }
}
